import React from 'react';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import env from '~/commons/config/env';

const LangTabs = ({
  children,
}) => (
  <Tabs
    defaultActiveKey="en"
  >
    {Object.keys(env.langs).map((ln) => (
      <Tab
        key={ln}
        eventKey={ln}
        title={env.langs[ln].label}
      >
        {children({ lang: ln })}
      </Tab>
    ))}
  </Tabs>
);

export default LangTabs;
